// extracted by mini-css-extract-plugin
module.exports = {"content":"banner_content__nHdb2","bg":"banner_bg__2M5Fe","logos_img":"banner_logos_img__17MbX","title":"banner_title__2L6uc"};